export const STANDARD_SIZE_QUALIFIER_ID = 1;

export const defaultSellingUnit = {
  idSu: 0,
  suName: '',
  total: '',
  umtCode: ''
};

export const defaultSizeQualifier = {
  id: -1,
  nameSizeQualifier: ''
};

export const defaultRegion = {
  id: 11,
  name: 'Quebec'
};

export const regionsFr = [
  {
    'id': 1,
    'name': 'Alberta'
  },
  {
    'id': 2,
    'name': 'Colombie-Britannique'
  },
  {
    'id': 10,
    'name': 'Île-du-Prince-Édouard'
  },
  {
    'id': 3,
    'name': 'Manitoba'
  },
  {
    'id': 4,
    'name': 'Nouveau-Brunswick'
  },
  {
    'id': 6,
    'name': 'Nouvelle-Écosse'
  },
  {
    'id': 9,
    'name': 'Ontario'
  },
  {
    'id': 11,
    'name': 'Québec'
  },
  {
    'id': 12,
    'name': 'Saskatchewan'
  },
  {
    'id': 5,
    'name': 'Terre-Neuve-et-Labrador'
  }
];

export const regionsEn = [
  {
    'id': 1,
    'name': 'Alberta'
  },
  {
    'id': 2,
    'name': 'British Columbia'
  },
  {
    'id': 3,
    'name': 'Manitoba'
  },
  {
    'id': 4,
    'name': 'New Brunswick'
  },
  {
    'id': 5,
    'name': 'Newfoundland Labrador'
  },
  {
    'id': 6,
    'name': 'Nova Scotia'
  },
  {
    'id': 9,
    'name': 'Ontario'
  },
  {
    'id': 10,
    'name': 'Prince Edward Island'
  },
  {
    'id': 11,
    'name': 'Quebec'
  },
  {
    'id': 12,
    'name': 'Saskatchewan'
  }
];
